import { Component, OnInit, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { CommsService } from '../../services/comms/comms.service';
import { ContractorService } from '../../services/contractor/contractor.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { DisplayService } from '../../services/display/display.service';
import { HelpService } from '../../services/help/help.service';
import { NoteService } from '../../services/note/note.service';
import { UserService } from '../../services/user/user.service';
import * as moment from 'moment';
import { localStorageKeys } from '../../constants';
import { TabService } from '../../services/tab/tab.service';
import { TableFilter, TableFilterService } from '../../services/table-filter/table-filter.service';

@Component({
	selector: 'pcm-data-page-timesheet',
	templateUrl: './data-page-timesheet.component.html',
	styleUrls: ['./data-page-timesheet.component.scss']
})
export class DataPageTimesheetComponent implements OnInit, OnDestroy {

	@ViewChild('fontSwitch') fontSwitch;
	@ViewChild('headerActionsSingle') headerActionsSingle;
	@ViewChild('headerActionsMulti') headerActionsMulti;

	title = 'Timesheet';
	poNumber;
	contractorId;
	supcontId;
	supplierId;
	loadDate;
	rejectionComment = '';
	dataObj;
	dataConfig;
	reasonCodes: any[];
	minDate: NgbDateStruct;
	maxDate: NgbDateStruct;
	removeFile: any = 0;

	fileDeletionListener;
	contractorUpdateListener;
	loadContractorPOsListener;
	loadTimesheetListener;
	public tooltips: any = {};
	showTooltips = false;
	activeContractorPOs = [];
	showExport = false;
	showConfirmation = false;
	confirmationMsg = 'Are you sure you want to perform the action on the timesheet?';
	currentEvent = '';

	jrSteps: any = [];
	jrStepIDs: string[] = [];

	// modal for copying claim codes
	showCopyClaimCodes: boolean = false;
	columnsConfigTSCopyILC: any = [];
	tab: any;
	hourTypes = [];

	// viewAllTimesheets = false;	//card 690
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private contractorService: ContractorService,
		public timesheetService: TimesheetService,
		public dataService: DataService,
		public configService: ConfigService,
		private displayService: DisplayService,
		private commsService: CommsService,
		private helpService: HelpService,
		private noteService: NoteService,
		public userService: UserService,
		private tabService: TabService,
		private tableFilterService: TableFilterService) {
		this.reasonCodes = [{
			name: 'Please select a reason code',
			prop: ''
		}];
		// build poSelections for ui-list only for contractor with more than one PO
		if (this.userService.persona === this.configService.personaProps.contractor) {
			if (!this.dataService.selectedPO) {
				this.contractorService.getContractorPOs();
				// if contractor has multiple POS
				// this.dataService.setContractorSelectedPO() will be called in the loadContractorPOsListener
			} else if (this.dataService.contractorPOs && this.dataService.contractorPOs.length > 1) {
				this.activeContractorPOs = this.dataService.contractorPOs.filter(contractor => {
					return contractor.po && !contractor.po.cancellation;
				});
				this.dataService.setContractorSelectedPO(this.activeContractorPOs);
			}
		}
	}

	ngOnInit() {
		this.timesheetService.awaitingContractor = true;
		this.dataObj = this.configService.timesheetDataObj;
		this.dataConfig = this.configService.getDataObj(this.dataObj);
		this.timesheetService.loadILCReasonCodes();
		this.timesheetService.retrieveNonBillableCodes();
		this.displayService.leftCollapse = true;

		// set up steps for joy ride tour guide
		this.jrSteps = [];
		this.jrStepIDs = [];
		this.helpService.timesheet.forEach(step => {
			this.jrSteps.push(step);
			this.jrStepIDs.push(step.id);
		});

		// need add jrRide inside the headerMenu component to get the correct bubble position
		this.jrStepIDs[this.jrStepIDs.length - 1] = ('headerMenu');

		this.tooltips = this.helpService.timesheet_tooltips;

		this.route.params.subscribe(params => {
			this.poNumber = params['poNumber'];
			if (this.userService.persona === this.configService.personaProps.contractor) {
				this.dataService.selectedPO = {
					name: this.poNumber,
					prop: this.poNumber
				};
			}

			this.contractorId = params['contractorId'];
			this.supcontId = params['supcontId'];
			this.supplierId = params['supplierId'];
			this.loadDate = params['loadDate'];
			this.configService.supplierId = this.supplierId;

			this.contractorService.loadContractor(this.poNumber, this.contractorId, this.supplierId);
			moment.updateLocale('en', {
				week: {
					dow: 6,
					doy: 6
				}
			});
		});

		this.fileDeletionListener = this.dataService.fileDeletionListener().subscribe((event) => {
			this.timesheetService.loadTimesheetDocs();
		});
		this.contractorUpdateListener = this.dataService.contractorUpdateListener().subscribe((event) => {
			this.getBankHolidays(this.dataService.contractorDetails[this.configService.countryCodeProp]);
			this.hourTypes = this.configService.getCountryConfig('hourTypes', this.dataService.contractorDetails[this.configService.countryCodeProp]);
			this.getDefaultAccounts(this.supplierId, this.dataService.contractorDetails[this.configService.countryCodeProp]);
			this.timesheetService.loadQuantityTypes(this.dataService.contractorDetails[this.configService.countryCodeProp]);
			this.timesheetService.awaitingContractor = false;
			this.timesheetService.contractorId = this.dataService.contractorDetails[this.configService.buyerContractorId];
			this.timesheetService.ilcSerial = this.dataService.contractorDetails[this.configService.ilcSerialNumProp];
			this.timesheetService.loadTimesheet(this.poNumber, this.contractorId, this.supcontId, this.supplierId, this.loadDate);
		});

		this.loadContractorPOsListener = this.contractorService.loadContractorPOsListener().subscribe((event) => {
			this.activeContractorPOs = this.dataService.contractorPOs.filter(contractor => {
				return contractor.po && !contractor.po.cancellation;
			});
			this.dataService.setContractorSelectedPO(this.activeContractorPOs);
		});

		this.loadTimesheetListener = this.dataService.timesheetLoadListener().subscribe((event) => {
			// only auto popup tour guide for new contractor who needs see privacy notice)
			if (this.userService.isContractor()
				&& localStorage.getItem(localStorageKeys.needRunTSTourGuide) !== 'false') {
				localStorage.setItem(localStorageKeys.needRunTSTourGuide, 'false');
				this.helpService.startTour(this.jrStepIDs);
			}
		});

		this.showTooltips =
			this.configService.canDo(this.dataConfig.fields, this.configService.timeentryProp, 'edit')
				&& this.dataService.getTimesheetStatus() !== this.configService.timesheetSubmitStatus;
	}

	ngOnDestroy() {
		console.log('DESTROY DATA PAGE TIMESHEET');
		this.fileDeletionListener.unsubscribe();
		this.contractorUpdateListener.unsubscribe();
		this.loadContractorPOsListener.unsubscribe();
		this.loadTimesheetListener.unsubscribe();
	}

	allowAction = () => {
		return true;
	}

	showSubmitCorrections() {

		const canEdit = this.configService.canDo(this.configService.getDataObj(this.configService.timesheetDataObj).fields, this.configService.timeentryProp, 'edit');

		const isContractor = this.userService.isContractor();

		const hoursLocked = this.dataService.isTimesheetHoursLock();

		const isLocked = this.timesheetService.isLocked();

		const isReconciled = this.dataService.isTimesheetCRR();

		const isReasoned = this.dataService.getTimesheetStatusDescription() === this.configService.timesheetReasonSubmittedStatus;

		let showSubmitCorrections = false;

		if (canEdit && isLocked) {
			showSubmitCorrections = true;
		}

		if (!this.dataService.contractorDetails.ilcenabled && isContractor &&
			hoursLocked && !isReasoned) {
			showSubmitCorrections = false;
		}

		if (isReconciled) {
			showSubmitCorrections = false;
		}

		return showSubmitCorrections;
	}

	reasonCodeAction(event) {
		this.dataService.updateReasoncode(event.action);
		this.timesheetService.saveTimesheet(this.configService.timesheetSaveStatus, false);
	}

	showMakeEdits() {
		let showMakeEdits = false;
		if (this.dataService.getTimesheetStatus() === this.configService.timesheetSubmitStatus
			|| this.dataService.getTimesheetApprovalStatus() === this.configService.timesheetRejectedStatus) {
			showMakeEdits = true;
		}

		if (!this.dataService.contractorDetails.ilcenabled && this.userService.isContractor() && this.dataService.isTimesheetHoursLock()) {
			showMakeEdits = false;
		}
		return showMakeEdits;
	}

	showMakeCorrections() {
		let showMakeCorrections = false;
		const isLocked = this.timesheetService.isLocked();
		if (this.configService.canDo(this.dataConfig.fields, this.configService.timeentryProp, 'edit')
			&& isLocked
			&& this.dataService.getTimesheetStatusDescription() !== this.configService.timesheetReasonSubmittedStatus) {
			showMakeCorrections = true;
		}

		if (!this.dataService.contractorDetails.ilcenabled && this.userService.isContractor() && this.dataService.isTimesheetHoursLock()) {
			showMakeCorrections = false;
		}

		return showMakeCorrections;
	}
	canAddRow() {
		const isLocked = this.dataService.getTimeLock();
		let canAddRow = !isLocked &&
			this.configService.canDo(this.dataConfig.fields, this.configService.timeentryProp, 'edit') &&
			this.dataService.getTimesheetStatus() !== this.configService.timesheetSubmitStatus;

		if (this.userService.isContractor() && this.dataService.isTimesheetHoursLock()) {
			canAddRow = false;
		}

		return canAddRow;
	}
	canAddCorrectionRow() {

		const isContractor = this.userService.isContractor();

		const canEdit = this.configService.canDo(this.dataConfig.fields, this.configService.timeentryProp, 'edit');

		const hoursLocked = this.dataService.isTimesheetHoursLock();

		let canAddCorrectionRow = canEdit && !this.showMakeCorrections();

		if (isContractor && hoursLocked) {
			canAddCorrectionRow = false;
		}

		return canAddCorrectionRow;
	}

	poSelectionAction(event) {
		const po = event.action.name;
		console.log('selected po number: ', po);
		const poObj = this.dataService.userKeys[po];
		this.dataService.selectedPO = {
			name: po,
			prop: po
		};
		if (poObj) {
			this.dataService.selectedPO.tooltip = poObj.actualstartdate + ' - ' + poObj.actualenddate;
			const poNumber = poObj[this.configService.poNumberProp];
			const contractorId = poObj[this.configService.contractorIdProp];
			const supcontId = poObj[this.configService.supcontIdProp];
			const supplierId = poObj[this.configService.supplierIdProp];
			let timesheetDate = poObj.actualenddate;
			const date = new Date();
			const actualEndTime = new Date(poObj.actualenddate).getTime();
			// if actualenddate is later that today, use today to load timesheet
			if (actualEndTime > date.getTime()) {
				timesheetDate = this.dataService.formatDate(date);
			}
			let personaPath = 'timesheet/' + poNumber + '/' + contractorId + '/' + supcontId + '/' + supplierId + '/' + timesheetDate;
			if (!supcontId) {
				personaPath = 'timesheet/' + poNumber + '/' + contractorId + '/' + supplierId + '/' + timesheetDate;
			}
			console.log('PERSONA PATH', personaPath);
			this.router.navigateByUrl(personaPath);
		} else {
			this.noteService.displayError('failed to find PO for: ' + po);
		}
	}

	showReasonCode() {
		let showCode = false;
		if (this.dataService.accounts && this.dataService.accounts.length > 0) {
			showCode = true;
		}
		return showCode;
	}

	disableApproval() {
		const persona = this.userService.persona.toLowerCase();
		if (persona === 'pm') {
			return this.dataService.getTimesheetSupplierStatus() === this.configService.timesheetRejectedStatus;
		} else if (persona === 'sam') {
			return this.dataService.getTimesheetBuyerStatus() === this.configService.timesheetRejectedStatus;
		}

		return false;
	}

	openTimesheet(date: string) {
		if (date === undefined || date === '') {
			return;
		}
		const poNumber = this.dataService.timesheetDetails[this.configService.poNumberProp];
		const contractorId = this.dataService.timesheetDetails[this.configService.contractorIdProp];
		const supcontId = this.dataService.timesheetDetails[this.configService.supcontIdProp];
		const supplierId = this.dataService.timesheetDetails[this.configService.supplierIdProp];
		this.loadDate = date;
		if (supcontId) {
			window.history.replaceState({}, '', '/timesheet/' + poNumber + '/' + contractorId + '/' + supcontId + '/' +
			supplierId + '/' + date);
		} else {
			window.history.replaceState({}, '', '/timesheet/' + poNumber + '/' + contractorId + '/' +
			supplierId + '/' + date);
		}
		this.timesheetService.loadTimesheet(poNumber, contractorId, supcontId, supplierId, date, false);
	
		this.removeFile++;
	}

	/**
	 * Gets the date seven days before the currently selected date.
	 * If the date is before PO po start date it returns an empty string
	 * @return {string} - a date formated as 'YYYY-MM-DD' or an empty string
	 */
	get previousWeek(): string {
		const currentWeek = moment(this.loadDate, 'YYYY-MM-DD');
		const validMin = moment(this.dataService.formatPickerDate(this.dataService.validTimesheetMin), 'YYYY-MM-DD');
		const diff = currentWeek.diff(validMin, 'days');
		const previousWeek = diff >= 7
			? currentWeek.subtract(7, 'days')
			: !currentWeek.isSame(validMin, 'week')
				? currentWeek.subtract(diff, 'days')
				: '';

		return previousWeek && previousWeek.isSameOrAfter(validMin)
			? previousWeek.format('YYYY-MM-DD')
			: '';
	}

	/**
	 * Gets the date seven days from the currently selected date.
	 * If the date is after the PO end date or past the end of the current week it returns an empty string
	 * @return {string} - a date formated as 'YYYY-MM-DD' or an empty string
	 */
	get nextWeek(): string {
		// convert dates to moment objects
		const loadDate = moment(this.loadDate, 'YYYY-MM-DD');
		const nextWeek = loadDate.add(7, 'days');
		const validTimesheetMax = moment(this.dataService.formatPickerDate(this.dataService.validTimesheetMax), 'YYYY-MM-DD');

		// Set up variables
		const beforeMax = nextWeek.isSameOrBefore(validTimesheetMax);
		const beforeWeek = loadDate.isSameOrBefore(validTimesheetMax, 'week');

		if (beforeMax && beforeWeek) {
			return nextWeek.format('YYYY-MM-DD');
		} else if (beforeWeek) {
			const diff = nextWeek.diff(validTimesheetMax, 'day');
			return nextWeek.subtract(diff, 'days').format('YYYY-MM-DD');
		} else {
			return '';
		}

	}


	getDefaultAccounts(supplierId = '', countrycode = this.configService.countryCodes.US) {
		console.log('GET DEFAULT ACCOUNTS');
		const curentDefault = this.configService.defaultOptions;
		this.configService.defaultOptions = [];
		this.configService.customOptions = [];
		this.commsService.getLineItems('LINEITEMS', 'DEFAULTLINEITEMS', supplierId, countrycode).subscribe(responseList => {
			try {
				const url1 = responseList[1];
				const url2 = responseList[0];
				if (url1['status'] === 'SUCCESS' && url2['status'] === 'SUCCESS') {
					this.configService.defaultOptions.push(... url1['detail'].value);
					if (url2['detail'] && url2['detail'].value) {
						this.configService.defaultOptions.push(... url2['detail'].value);
						this.configService.customOptions.push(... url2['detail'].value);
					}
				} else {
					console.log('getDefaultAccounts Error:', 'Issue seting default line items from API, check Supplier Admin has configured this sucsessfully');
					this.configService.defaultOptions = curentDefault;
				}
				console.log('PARSED DEFAULT ACCOUNTS', this.configService.defaultOptions);
			} catch (e) {
				console.log('getDefaultAccounts Error:', e);
				this.configService.defaultOptions = curentDefault;
			}

		});
	}

	getBankHolidays(countryCode: string) {
		// for now just get bank holidays for UK
		// in the future if needed, need get countrycode after TS is loaded
		this.commsService.getAllBankHolidays(countryCode).subscribe((res) => {
			const successData = this.commsService.getSuccessData(res);
			// if no countrycode filter
			// API returns an array of the countries
			if (successData.length > 0) {
				this.dataService.bankHolidays = successData[0].caldates;
			}
		}, (err) => {
			this.commsService.handleAPIError('Load all bank holidays', err);
		});
	}

	isSmall() {
		if (this.fontSwitch !== undefined) {
			return this.fontSwitch.isSmall();
		} else {
			return false;
		}
	}

	showExportModal() {
		this.showExport = true;
	}

	closeExportModal() {
		this.showExport = false;
	}

	exportToPDF(event) {
		const delay = setTimeout(() => {
			this.closeExportModal();
		}, 1000);
		const content = document.getElementById('timesheet-data-page-body');
		this.dataService.downloadToPDF(content, event.data)
	}

	showConfirmationModal(action: string) {
		this.currentEvent = action;
		if (action === 'archive') {
			this.confirmationMsg = 'Are you sure you want to archive the timesheet? Archiving the timesheet will remove it from the list of timesheets and make it unavailable to submit.';
		} else if (action === 'restore') {
			this.confirmationMsg = 'Are you sure you want to restore the timesheet?';
		} else if (action === 'submit') {
			this.confirmationMsg = 'You already have a submitted timesheet for this week under ' +
			this.dataService.timesheetDetails.duplicate?.ponumbers.toString() +
			'. Are you sure you want to submit a duplicate timesheet?';
		} else if (action === 'copyClaimCodes') {
			this.confirmationMsg = 'Are you sure you want to replace your claim codes?';
		}
		this.showConfirmation = true;
	}

	confirmMakeEdits(event, isCorrection) {
		this.confirmationMsg = 'Are you sure you want to make edits to your timesheet? Once you confirm, your timesheet will revert to "unsubmitted" (saved) status. Your timesheet will be considered unsubmitted (saved) until you resubmit your timesheet to go through the verification process again.';
		this.currentEvent = 'makeEdit';
		// event.action is the selected reason code
		// this will only update the reason code in the dataService but not update the backend if the user cancels
		this.dataService.updateReasoncode(event.action);
		if (isCorrection) {
			this.confirmationMsg = 'Are you sure you want to make corrections to your timesheet? Once you confirm, your timesheet will revert to "Reason Code Submitted" (saved) status, and your timesheet will be considered unsubmitted (saved) until you resubmit the correction timesheet to go through the verification process again.';
		} else if (this.dataService.contractorDetails.ilcenabled) {
			this.confirmationMsg = this.confirmationMsg.concat(' If you want to edit your claim code, please click "Clear Search Inputs" first then input your new code. If you want to edit your hours, please reach out to your supplier.');
		}
		this.showConfirmation = true;
	}

	closeConfirmationModal() {
		this.showConfirmation = false;
		// need reset reasoncode
		if (this.currentEvent === 'makeEdit') {
			this.dataService.updateReasoncode(null);
		}
	}

	confirmationFormSubmit() {
		// need call API to archive TS
		this.showConfirmation = false;
		let data = {};
		if (this.currentEvent === 'archive' || this.currentEvent === 'restore') {
			data = {
				id: this.dataService.timesheetDetails['id']
			};
			this.displayService.startLoading();
		}

		if (this.currentEvent === 'archive') {
			this.commsService.archiveTimesheet(data).subscribe((res) => {
				this.displayService.endLoading();
				// route to dashboard
				this.router.navigateByUrl('');
			}, (err) => {
				this.displayService.endLoading();
				this.commsService.handleAPIError('Archive timesheet', err);
			});
		} else if (this.currentEvent === 'restore') {
			this.commsService.restoreTimesheet(data).subscribe((res) => {
				this.displayService.endLoading();
				// refresh the current page
				this.openTimesheet(this.loadDate);
			}, (err) => {
				this.displayService.endLoading();
				this.commsService.handleAPIError('Restore timesheet', err);
			});
		} else if (this.currentEvent === 'submit') {
			this.timesheetService.saveTimesheet(this.configService.timesheetSubmitStatus);
		} else if (this.currentEvent === 'makeEdit') {
			this.timesheetService.submitReasonCode(this.dataService.reasoncode);
		} else if (this.currentEvent === 'copyClaimCodes') {
			this.showCopyClaimCodesModal();
		}
	}

	canArchive() {
		let canArchive = false;
		// persona need be either contractor or SAM
		// and archive prop is either unavailable or blank
		// and TS must be saved original TS
		if ((this.userService.persona === this.configService.personaProps.contractor ||
			this.userService.persona === this.configService.personaProps.sam) &&
			!this.dataService.timesheetDetails[this.configService.timesheetArchiveProp] &&
			this.dataService.getTimesheetStatusDescription() === this.configService.timesheetUnsubmitStatus &&
			!this.timesheetService.isLocked()) {
			canArchive = true;
		}
		return canArchive;
	}

	canRestore() {
		let canRestore = false;
		// persona need be either contractor or SAM
		// and archive prop is not blank
		if ((this.userService.persona === this.configService.personaProps.contractor ||
			this.userService.persona === this.configService.personaProps.sam) &&
			this.dataService.timesheetDetails[this.configService.timesheetArchiveProp]) {
			canRestore = true;
		}
		return canRestore;
	}

	submitTimesheet(submitStatus) {
		if (this.dataService.timesheetDetails.duplicate) {
			this.showConfirmationModal('submit');
		} else {
			this.timesheetService.saveTimesheet(submitStatus);
		}
	}

	isZeroRowsInvalid() {
		return !this.timesheetService.rowsZeroValid || !this.timesheetService.correctRowsZeroValid;
	}

	showSubmit() {
		const showBtn =  this.configService.canDo(this.dataConfig.fields, this.configService.timeentryProp, 'edit')
			&& !this.showMakeEdits()
			&& !this.timesheetService.isLocked()
			&&	!this.canRestore();
		return showBtn;
	}

	showCopyClaimCodesModal() {
		// construct table colums if needed
		if(this.columnsConfigTSCopyILC.length === 0) {
			// to support timesheet table in copying claim code popup
			const tableFields = this.configService.getTableFields(this.dataObj, true);
			this.columnsConfigTSCopyILC = [];
			tableFields.forEach(field => {
				if (field.prop === this.configService.poNumberProp
					|| field.prop === this.configService.timesheetEndProp
					|| field.prop === this.configService.timesheetStatusUIProp) {
					this.columnsConfigTSCopyILC.push(field);
				}
			});
		}
		// need populate dataService.pageData[tabObj] for table rows
		this.tab = this.timesheetService.tabsData.listTabs[3];
		this.tab.pageSize = 10;

		// only needs ILC timesheets
		this.tableFilterService.removeAllFiltersFromTab(this.tab.tableFilters);
		let searchField: TableFilter = {
			propName: this.configService.contractorILCProp,
			value: true
		};
		this.tableFilterService.addFilter(this.tab.tableFilters, searchField);

		// need load contractor (same buyercontractorid) timesheets for SAM
		if (this.userService.persona === this.configService.personaProps['sam']) {
			searchField = {
				propName: this.configService.buyerContractorId,
				value: this.dataService.timesheetDetails[this.configService.buyerContractorId]
			};
			this.tableFilterService.addFilter(this.tab.tableFilters, searchField);
		}

		this.tabService.loadTab(this.timesheetService.tabsData.listTabs, this.timesheetService, 'all');

		this.showCopyClaimCodes = true;
	}

	cancelCopyClaimCodesModal() {
		this.tableFilterService.removeAllFiltersFromTab(this.tab.tableFilters);
		delete this.tab['pageSize'];
		this.showCopyClaimCodes = false;
	}

	copyClaimCodesSubmit(event) {
		if (!event.clickedTableRow) {
			this.noteService.displayWarning('Please select a timesheet by clicking a table row to continue');
		} else {
			// loadTimesheet with a new extra parm: id of the copied TS
			this.timesheetService.loadTimesheet(this.poNumber, this.contractorId, this.supcontId, this.supplierId, this.loadDate, false, event.clickedTableRow.id);

			this.cancelCopyClaimCodesModal();
		}
	}

	checkClaimCodes() {
		// if TS already has claim code, need confirm
		if (this.timesheetService.hasILCClaimCodes()) {
			this.showConfirmationModal('copyClaimCodes');
		} else {
			this.showCopyClaimCodesModal();
		}
	}
}
